export default __webpack_public_path__ + "static/media/edit.f3540259.svg";